// const getNewsEndPoint = "https://localhost:44353/umbraco/delivery/api/v2/content/?fetch=children%3A%2Fmidlands-connect%2Fpublications&skip=0&take=500";
const getNewsEndPoint = "/umbraco/delivery/api/v2/content/?fetch=children%3A%2Fmidlands-connect%2Fpublications&skip=0&take=500";

const getApiData = async () => {
  const token = '54191bfa-d83f-4f8d-80ba-54587374b638';
  const response = await fetch(getNewsEndPoint, {
    headers: {
      'Api-Key': `${token}`
    }
  });
  const parsedResponse = await response.json();
  // console.log(parsedResponse);
  return parsedResponse;
};

export default getApiData;